export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-tab-page/index.js